
import React from 'react';
import { uid } from 'uid';
import { LGA, STATION } from '../../interfaces/shipping.interface';


export const getAddressComponent = (
    geoData: google.maps.GeocoderResult[],
    searchKey: string
  ) => {
    const addressComponet = geoData[0].address_components?.find(
      (address_component) => address_component.types.includes(searchKey)
    );
    return addressComponet;
  };

export const getLgaFromGeoData = (
    geoData: google.maps.GeocoderResult[],
    lgasArg: LGA[]
  ): LGA | null => {
    const GeoLga = getAddressComponent(geoData, 'administrative_area_level_2');
    const selectedLga = lgasArg?.find(
      (lga) =>
        lga?.LGAName?.toLowerCase()?.replace(/[^a-zA-Z0-9]/g, '_') ===
        GeoLga?.long_name.toLowerCase()?.replace(/[^a-zA-Z0-9]/g, '_')
    );
    return selectedLga || null;
  };

  export const getStationFromGeoData = (
    geoData: google.maps.GeocoderResult[],
    stationsarg: STATION[]
  ): STATION | null => {
    const GeoStation = getAddressComponent(
      geoData,
      'administrative_area_level_1'
    );
    const selectedStation = stationsarg?.find((station) =>
      GeoStation?.long_name
        ?.toLowerCase()
        ?.includes(station.StationName.toLowerCase())
    );
    return selectedStation || null;
  };
  